export default "__VITE_ASSET__CA2Wcg5A__"